// assets
import ArchiveTwoToneIcon from '@mui/icons-material/ArchiveTwoTone';

export const state = {};

export const reducer = {};

export const gridActions = (row, permissionData, onClickActions) => {
    const gridActions = [];

    permissionData?.forEach((perm) => {
        switch (perm) {
            case 'canArchive':
                if (row?.deletedAt || !['awarded', 'completed', 'canceled'].includes(row?.state)) {
                    return;
                }

                gridActions.push({
                    key: `actionarchive-row${row?.id}`,
                    icon: <ArchiveTwoToneIcon fontSize="small" />,
                    label: 'ui-comp-button-archive',
                    position: 6,
                    showInMenu: true,
                    onClick: () => {
                        if (
                            'onClickRowActionArchive' in (onClickActions || {}) &&
                            typeof onClickActions.onClickRowActionArchive === 'function'
                        ) {
                            onClickActions.onClickRowActionArchive(row);
                        }
                    }
                });
                break;
            default: // do nothing
        }
    });

    return gridActions;
};
